<template>
  <div class="">
    <Head title="Crear Perfil de Empresa"></Head>
    <div class="container-fluid px-0">
      <div class="lpg-header position-relative">
        <img src="/images/lpg-rect-4.png" class="img-fluid vw-100" alt="..." />
        <h1 class="position-absolute">Actualización de datos</h1>
      </div>
    </div>
    <div class="container-fluid py-5">
      <div class="row">
        <div class="col-12 col-md-10 col-lg-6 mx-auto">
          <form @submit.prevent="updateCompanyProfile" class="lpg-form px-3">
            <h2 class="lpg-form-title">Información general de la empresa</h2>
            <text-input
              id="company_name"
              v-model="form.name"
              label="Nombre de la empresa"
              :required="true"
              :placeholder="form.name"
            ></text-input>
            <textarea-input
              id="description"
              v-model="form.description"
              label="Descripción de la empresa"
              :required="true"
              :placeholder="'Empresa de alto prestigio y renombre nacional...'"
              :maxlength="500"
            />
            <select-input
              v-model="form.company_size_id"
              label="Tamaño de la empresa"
              id="company_size"
              :required="true"
            >
              <option value="" disabled>Seleccionar</option>
              <option v-for="size in company_sizes" :key="size.id" :value="size.id">
                {{ size.name }} ({{ size.min_employee_count }} -
                {{ size.max_employee_count }} empleados)
              </option>
            </select-input>
            <select-input
              v-model="form.company_category_id"
              label="Rubro"
              name="company_category"
              :required="true"
            >
              <option value="" disabled>Seleccionar</option>
              <option
                v-for="category in company_categories"
                :key="category.id"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select-input>
            <textarea-input
              id="company_mission"
              v-model="form.company_mission"
              label="Misión"
              name="company_mission"
              :maxlength="300"
            >
            </textarea-input>
            <textarea-input
              id="company_vision"
              v-model="form.company_vision"
              label="Visión"
              name="company_vision"
              :maxlength="300"
            >
            </textarea-input>
            <textarea-input
              id="company_values"
              v-model="form.company_values"
              label="Valores"
              name="company_values"
              :maxlength="300"
            >
            </textarea-input>
            <h2 class="lpg-form-title">Redes sociales</h2>
            <text-input
              id="website_url"
              v-model="form.website_url"
              label="Sitio web"
              placeholder="https://"
              icon="bi bi-globe2"
              icon_color="#8e8e8e"
            ></text-input>
            <text-input
              id="fb_url"
              v-model="form.fb_url"
              label="Facebook"
              placeholder="https://"
              icon="bi bi-facebook"
              icon_color="#8e8e8e"
            ></text-input>
            <text-input
              id="ig_url"
              v-model="form.ig_url"
              label="Instagram"
              placeholder="https://"
              icon="bi bi-instagram"
              icon_color="#8e8e8e"
            ></text-input>
            <text-input
              id="linkedin_url"
              v-model="form.linkedin_url"
              label="Linkedin"
              placeholder="https://"
              icon="bi bi-linkedin"
              icon_color="#8e8e8e"
            ></text-input>

            <button
              type="submit"
              class="btn btn-secondary mx-auto d-block mt-5"
              :disabled="form.progress"
            >
              <span
                :class="{
                  'visually-hidden': !form.progress,
                  'spinner-border spinner-border-sm': form.progress,
                }"
                role="status"
                aria-hidden="true"
              ></span>
              Guardar
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutEmpresas from '@/Layouts/LayoutEmpresas.vue'
import TextInput from '@/Components/Form/TextInput.vue'
import SelectInput from '@/Components/Form/SelectInput.vue'
import TextareaInput from '@/Components/Form/TextareaInput.vue'

export default {
  name: 'CompanyProfileCreate',
  layout: LayoutEmpresas,
  components: {
    Head,
    TextInput,
    SelectInput,
    TextareaInput,
  },
  props: {
    company: Object,
    company_sizes: Array,
    company_categories: Array,
  },
  data() {
    return {
      form: this.$inertia.form({
        name: this.company.name,
        description: this.company.description,
        company_mission: this.company.company_mission,
        company_vision: this.company.company_vision,
        company_values: this.company.company_values,
        website_url: this.company.website_url,
        fb_url: this.company.fb_url,
        ig_url: this.company.ig_url,
        linkedin_url: this.company.linkedin_url,
        company_size_id: this.company.company_size_id,
        company_category_id: this.company.company_category_id,
      }),
    }
  },
  methods: {
    updateCompanyProfile() {
      this.form.put(this.$route('company.profile.update'))
    },
  },
}
</script>
